import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-74b1de62"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "h-100" }
const _hoisted_2 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode($setup["Navigation"]),
    _createElementVNode("div", null, [
      _createElementVNode("img", {
        src: require('@/assets/img/SCAN_REGISTRATION.png')
      }, null, 8 /* PROPS */, _hoisted_2)
    ]),
    _createElementVNode("button", {
      class: "btn btn-primary button-design",
      onClick: $setup.goToPage
    }, " Go to Registration ")
  ]))
}